export const VossIntermediaryStatus = {
    All: 0,
    Active: 1,
    Disabled: 2
};